import { render, staticRenderFns } from "./JdsInspector.vue?vue&type=template&id=20eba35c&scoped=true&"
import script from "./JdsInspector.vue?vue&type=script&lang=ts&"
export * from "./JdsInspector.vue?vue&type=script&lang=ts&"
import style0 from "./JdsInspector.vue?vue&type=style&index=0&id=20eba35c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eba35c",
  null
  
)

export default component.exports